import Reveal from "@/components/Reveal";
import { ScanEye, Wrench } from "lucide-react";

const tools = ["Eye tracking", "EEG", "fMRI", "Facial coding", "GSR", "Investigación implícita"];

const Learn = () => (
  <section className="relative mx-auto max-w-7xl px-6 py-28 md:px-12 md:py-40" data-testid="learn-section">
    <div className="grid gap-16 md:grid-cols-12">
      <div className="md:col-span-8">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
            <ScanEye className="h-4 w-4" /> Qué vas a aprender
          </p>
          <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-5xl">
            Herramientas de neuromarketing,{" "}
            <span className="text-stroke-magenta">pero sin presupuesto de multinacional</span>
          </h2>
          <p className="mt-8 text-sm leading-relaxed text-lilac/90 md:text-base">
            Vas a conocer cómo el neuromarketing estudia la atención, la emoción, la memoria,
            la percepción y la toma de decisiones, y cómo aproximarte a sus hallazgos con
            ejercicios, herramientas digitales y métodos proxy, sin gran presupuesto de investigación.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap gap-2">
            {tools.map((t) => (
              <span
                key={t}
                className="border border-violet/40 bg-violet/10 px-3 py-1.5 text-xs uppercase tracking-[0.15em] text-lilac"
              >
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>

    <div className="mt-32 grid gap-16 md:grid-cols-12">
      <div className="md:col-span-6">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs font-medium uppercase tracking-[0.35em] text-magenta">
            <Wrench className="h-4 w-4" /> Un curso práctico e interactivo
          </p>
          <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-5xl">
            Todo lo que aprendés, <span className="text-neoncyan">lo aplicás en el momento</span>
          </h2>
          <p className="mt-8 max-w-lg text-sm leading-relaxed text-lilac/90 md:text-base">
            Durante las tres sesiones trabajamos directamente sobre las marcas de los
            participantes: comunicación, identidad visual, propuesta de valor, precios, oferta,
            proceso de compra y presencia digital. Si todavía no tenés marca propia, vas a
            practicar con las de tus compañeros y con casos reales del mercado.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 max-w-lg overflow-hidden border border-white/10">
            <img
              src="/assets/maria-ambiente.png"
              alt="María Elizabeth en su estudio de investigación"
              className="w-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>
        </Reveal>
      </div>
      <div className="md:col-span-6">
        <Reveal delay={0.1}>
          <div className="flex h-full items-center border border-white/10 bg-black/20 p-8 md:p-12">
            <p className="font-editorial text-2xl italic leading-relaxed text-rosewhite/90 md:text-3xl">
              Vas a hacer auditorías visuales, tests cruzados entre participantes, heatmaps
              predictivos con IA, análisis de precios y arquitectura de oferta, y una auditoría
              de percepción digital con ChatGPT, Claude y Gemini.{" "}
              <span className="text-magenta">Todo aplicado a marcas reales.</span>
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Learn;
